export default "__VITE_ASSET__2ad19a5a__"